import GenericAreaPage from "@/components/GenericAreaPage";
import { getAreaContent } from "@/lib/area-content";

const WestUniversity = () => {
  const content = getAreaContent("west-university");
  if (!content) return null;
  return <GenericAreaPage content={content} />;
};

export default WestUniversity;